import React        from "react";
import PropTypes    from 'prop-types';
import Flux         from './../../flux/Flux';
import Translations from './../../utils/Translations';
import Constants, { getTypeByColor }    from './Constants';
import Alert from "../Alert/Alert";

class StatusBarNoVerifiedEmail extends React.Component {

	static validateEmail(email) {
		const re = Flux.Constants.RegExp.EMAIL;
		return re.test(email);
	}

	constructor(props) {
		super(props);
		this.state = {
			canSendEmail: false,
			email:        '',
			changedEmail: null,
			canSendTan:   true,
			isVisible:    this.props.isVisible,
		};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e) {
        const value = e.target.value;
		this.setState({
			email:        value,
			canSendEmail: StatusBarNoVerifiedEmail.validateEmail(value),
		});
	}

	getGuestMail() {
		return this.state.changedEmail ? this.state.changedEmail : Flux.Guest.getEmailAddress();
	}

	render() {
        if (!this.state.isVisible) {
            return null;
        }

		const onSendSignupEmailClick = () => {
            console.log('onSendSignupEmailClick');
			Flux.Notification.sendSignupEmail();
			this.setState({
				canSendTan: false,
			});
		};
		const onChangeEmailClick     = () => {
			Flux.Notification.sendSignupEmail(this.state.email);
			this.setState({
				changedEmail: this.state.email,
				email:        '',
				canSendEmail: false,
				canSendTan:   true,
			});
		};

		const messagetext = this.getGuestMail() ? this.props.msgIntro.replace(':guestMail', this.getGuestMail()) : Translations.get('common.status-bar-no-email-intro');
		let submessage    = this.getGuestMail() ? this.props.msgOutro : Translations.get(Flux.Browser.isSexole() ? 'common.status-bar-no-email-outro_sexole' : 'common.status-bar-no-email-outro');
        let textButton    = null;

        if (this.getGuestMail()) {
            submessage += "<br /> <br />" + this.props.sendWelcomeMailText;
            textButton = {text: this.props.sendWelcomeMailButtonLbl, onClick: onSendSignupEmailClick, isDisabled: !this.state.canSendTan};
        }

        return <Alert
            type={getTypeByColor(this.props.barColor)}
            headline={messagetext}
            text={submessage}
            textButton={textButton}
            inputField={{text: this.getGuestMail() ? this.props.sendWelcomeMailChangeMailText : "", inputText: this.state.email, buttonText: Translations.get('BtnSend'), onButtonClick: onChangeEmailClick, isButtonDisabled: !this.state.canSendEmail, onInputChange: this.handleChange}}
            onClose={() => {this.setState({isVisible: false});}}
        />;
	}
}

StatusBarNoVerifiedEmail.propTypes = {
	barColor:                      PropTypes.string.isRequired,
	msgIntro:                      PropTypes.string.isRequired,
	msgOutro:                      PropTypes.string.isRequired,
	isVisible:                     PropTypes.bool.isRequired,
	sendWelcomeMailButtonLbl:      PropTypes.string.isRequired,
	sendWelcomeMailText:           PropTypes.string.isRequired,
	sendWelcomeMailChangeMailText: PropTypes.string.isRequired,
};

StatusBarNoVerifiedEmail.defaultProps = {
	barColor: Constants.BARCOLOR_BLUE,
};

export default StatusBarNoVerifiedEmail;
